import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { LangStore } from "./types";

const useLang = create<LangStore>()(
    persist(
        (set) => ({
            lang: null,
            setLang: (lang) => set({ lang }),
        }),
        { name: "lang" }
    )
);

export default useLang;
